import React, { useEffect } from "react";
import type { FC } from "react";
import { useDispatch } from "react-redux";
import { usePalette } from "react-palette";
import { toCoverUrl } from "store/baseUrls";
import { useShallowPickSelector } from "store/useSelector";
import { playerActions } from "store/player/player.slice";

interface PaletteProps {}

export const Palette: FC<PaletteProps> = () => {
  const { currentTrack } = useShallowPickSelector("player", ["currentTrack"]);

  const dispatch = useDispatch();

  const { data: palette } = usePalette(
    currentTrack?.coverLink || toCoverUrl(null)
  );

  useEffect(() => {
    if (palette && palette.darkVibrant) {
      dispatch(playerActions.setBackgroundColor(palette.darkVibrant));
    }
  }, [palette]);

  return null;
};
